import { LegalEntityType } from '../user-page-lecturer-rate-accountant';
import appApi from '../../../../../../../api/app-api';
import { toast } from 'react-toastify';

export const updateLecturerRateAccountantOperation = async (
  branchId: number,
  lecturerId: number,
  rateId: number,
  legalEntityType: LegalEntityType,
  reportingCode: string,
  legalEntityId: string | null,
) => {
  try {
    // Convert null to empty string since API expects a string
    const entityId = legalEntityId || undefined;

    await appApi.updateLecturerAccountantData(
      branchId,
      lecturerId,
      rateId,
      legalEntityType,
      reportingCode,
      entityId,
    );

    toast.success('נתוני החשבונות נשמרו בהצלחה');
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
    console.error(
      `updateLecturerRateAccountantOperation is failed with the rateId: ${rateId}, legalEntityType: ${legalEntityType}, reportingCode: ${reportingCode}, legalEntityId: ${legalEntityId} with the error: ${e}`,
    );
  }
};
